import { toast } from "sonner";
import { BRAND } from "@/config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const productLink = (product) => `${API}/share/${encodeURIComponent(product.sku || product.id)}`;

const shareText = (product) =>
  [
    product.name,
    product.sku ? `Code: ${product.sku}` : null,
    product.category || null,
    "",
    `See it on ${BRAND}:`,
  ]
    .filter(Boolean)
    .join("\n");

async function shareImageFile(product) {
  try {
    const res = await fetch(`${API}/share/${encodeURIComponent(product.sku || product.id)}/image`);
    if (!res.ok) return null;
    const blob = await res.blob();
    const file = new File([blob], `${product.sku || "product"}-varsha.jpg`, { type: "image/jpeg" });
    return navigator.canShare?.({ files: [file] }) ? file : null;
  } catch {
    return null;
  }
}

export async function shareProduct(product) {
  const url = productLink(product);
  const title = `${product.name} — ${BRAND}`;
  const text = shareText(product);

  if (navigator.share) {
    const file = await shareImageFile(product);
    try {
      await navigator.share(file ? { title, text: `${text}\n${url}`, files: [file] } : { title, text, url });
      return;
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }

  try {
    await navigator.clipboard.writeText(`${text}\n${url}`);
    toast.success("Product link copied — the photo shows up when you paste it");
  } catch {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`, "_blank");
  }
}

export function shareOnWhatsApp(product) {
  const text = `${product.name}${product.sku ? ` (${product.sku})` : ""}\n${productLink(product)}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
}
